import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaypointService } from '../../services/paypoint.service';
import { PaymentProcessService, PaymentProcessState } from '../../services/payment-process.service';
import { PaymentDetailsTabComponent } from './payment-details-tab/payment-details-tab.component';
import { PaymentMethodTabComponent } from './payment-method-tab/payment-method-tab.component';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-process-payment',
  templateUrl: './process-payment.component.html',
  styleUrls: ['./process-payment.component.scss'],
})
export class ProcessPaymentComponent implements OnInit, OnDestroy {
  processing = false;
  submitting = false;
  submitData = { success: false, message: '', description: '' };
  tabs: string[] = ['Details', 'Method', 'Review'];
  activeTabIdx = 0;
  triggerSave = false;
  @ViewChild(PaymentDetailsTabComponent) paymentDetails!: PaymentDetailsTabComponent;
  @ViewChild(PaymentMethodTabComponent) paymentMethod!: PaymentMethodTabComponent;

  payment: PaymentProcessState;
  private paymentMethodSubscription: Subscription;
  constructor(
    private paymentService: PaypointService,
    private processPaymentService: PaymentProcessService,
    public dialogRef: MatDialogRef<ProcessPaymentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      companyId: number;
      organization: string;
      office: any;
      customerId: string;
      taskId: string;
      taskEntities: any;
    },
  ) {}

  ngOnDestroy() {
    if (this.paymentMethodSubscription) {
      this.paymentMethodSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.processPaymentService.state$.subscribe((state) => {
      this.payment = state;
    });
  }

  save() {
    switch (this.activeTabIdx) {
      case this.tabs.indexOf('Details'):
        if (this.paymentDetails.save()) {
          this.activeTabIdx = this.activeTabIdx + 1;
        }
        break;

      case this.tabs.indexOf('Method'):
        this.handlePaymentMethodStep();
        break;

      case this.tabs.indexOf('Review'):
        this.processPayment();
        break;
    }
  }

  private handlePaymentMethodStep() {
    // Unsubscribe from previous subscription if it exists
    if (this.paymentMethodSubscription) {
      this.paymentMethodSubscription.unsubscribe();
    }

    this.processPaymentService.triggerGenerateToken();

    this.paymentMethodSubscription = this.processPaymentService.state$
      .pipe(
        map((state) => state.payment_method),
        distinctUntilChanged(),
        filter((method) => !!method), // triggers only when a valid payment_method is set
        take(1), // Only take the first valid emission
      )
      .subscribe(() => {
        this.activeTabIdx++;
      });
  }

  processPayment(): void {
    this.processing = true;

    this.paymentService
      .processPayment(this.data.organization, {
        ...this.payment,
        customer_id: this.payment.contact.contactUUID,
        amount: Number(this.payment.amount),
        source_type: 'TASK',
        source_id: this.data.taskId.toString(),
      })
      .subscribe(
        () => {
          this.processing = false;
          this.submitting = true;
          this.submitData = {
            success: true,
            message: 'Payment processed successfully.',
            description: '',
          };
        },
        (error) => {
          this.processing = false;
          this.submitting = true;
          this.submitData = {
            success: false,
            message: 'Failed to process payment. Please try again.',
            description: error,
          };
        },
      );
  }

  cancel(): void {
    this.dialogRef.close(); // Close the dialog without sending data
  }
  reTry(): void {
    this.dialogRef.close({ reTry: true }); // Close the dialog without sending data
  }
}
